import { toast, type ExternalToast } from 'sonner';

const TITLES = {
  success: 'Action completed',
  error: 'Action failed',
  warning: 'Attention needed',
  info: 'Information updated',
} as const;

const SUBTITLES = {
  success: 'Everything worked as expected.',
  error: "That didn't work as expected.",
  warning: 'Review this before continuing.',
  info: "This update doesn't require action.",
} as const;

function build(
  type: keyof typeof TITLES,
  message?: string,
  opts?: ExternalToast,
): [string, ExternalToast] {
  const title = TITLES[type];
  const fallback = SUBTITLES[type];
  return [title, { description: message || fallback, ...opts }];
}

export const notify = {
  success(message?: string, opts?: ExternalToast) {
    const [title, merged] = build('success', message, opts);
    return toast.success(title, merged);
  },
  error(message?: string, opts?: ExternalToast) {
    const [title, merged] = build('error', message, opts);
    return toast.error(title, merged);
  },
  warning(message?: string, opts?: ExternalToast) {
    const [title, merged] = build('warning', message, opts);
    return toast.warning(title, merged);
  },
  info(message?: string, opts?: ExternalToast) {
    const [title, merged] = build('info', message, opts);
    return toast.info(title, merged);
  },
  /** Closes one toast by the id a call above returned; without an id, closes them all. */
  dismiss(id?: string | number) {
    toast.dismiss(id);
  },
};
